import { ValuePropsArg } from '@components/ValuePropsSection';

export const HERO_VIDEO_URL = 'https://player.vimeo.com/video/844416468?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479';

export const VALUE_PROPS_ELEMENT_ID = 'baby-value-props';

export const BABY_REGISTRY_VALUE_PROPS: ValuePropsArg[] = [
  {
    id: 'babyValuePropsFreeShipping',
    url: 'https://help.withjoy.com/baby-registry/free-shipping',
    icon: 'freeShipping',
    title: 'Free <br />Shipping',
  },
  {
    id: 'babyValuePropsCompletionDiscount',
    url: 'https://help.withjoy.com/baby-registry/20-post-baby-registry-discount',
    icon: 'tag',
    title: '20% Completion <br />Discount',
  },
  {
    id: 'babyValuePropsZeroFeeCashFunds',
    url: 'https://help.withjoy.com/baby-registry/are-there-any-fees-when-using-baby-cash-funds',
    icon: 'noFees',
    title: 'Zero-Fee <br />Cash Funds',
  },
  {
    id: 'babyValuePropsEasyReturns',
    url: 'https://help.withjoy.com/baby-registry/easy-returns',
    icon: 'syncItem',
    title: 'Easy <br />Returns',
  },
];
